import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import {NewDeleteIcon} from "./NewAssetAndProjectCards";
import React from "react";

const DeleteProjectButton = ({handleClick}) => {

    return (
        <Tooltip title="Delete Project">
            <IconButton onClick={handleClick} sx={{
                color: "var(--app-icon-primary)",
                fontSize: '1rem', // Increase the font size
                // You can also adjust the size of the icon itself
                '& .MuiSvgIcon-root': {fontSize: '1.5rem'}
            }} disabled={false}>
                <NewDeleteIcon />
            </IconButton>
        </Tooltip>
    );
};

export default DeleteProjectButton;
